import { memo } from 'react';
import { cn } from '@/lib/utils';
import { ITemperatureBadgeProps, TLeadTemperature } from '@/@types/leads';

const temperatureConfig: Record<TLeadTemperature, { label: string; className: string }> = {
  hot: {
    label: 'Hot',
    className: 'bg-[#EC4899]/20 text-[#EC4899] border-[#EC4899]',
  },
  warm: {
    label: 'Warm',
    className: 'bg-[#F59E0B]/20 text-[#F59E0B] border-[#F59E0B]',
  },
  cold: {
    label: 'Cold',
    className: 'bg-[#06B6D4]/20 text-[#06B6D4] border-[#06B6D4]',
  },
};

export const TemperatureBadge = memo(function TemperatureBadge({
  temperature,
  size = 'md',
}: ITemperatureBadgeProps) {
  const config = temperatureConfig[temperature];

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded border font-medium',
        config.className,
        size === 'sm' ? 'min-w-[52px] px-2.5 py-1 text-xs' : 'min-w-[60px] px-3 py-1.5 text-sm'
      )}
    >
      {config.label}
    </span>
  );
});
